"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_ICON_POSITIONS = exports.BUTTON_SIZES = exports.BUTTON_VARIANTS = void 0;
const BUTTON_VARIANTS = ["primary", "secondary", "tertiary", "dashed", "darkBackground"];
exports.BUTTON_VARIANTS = BUTTON_VARIANTS;
const BUTTON_SIZES = ["small", "medium", "large"];
exports.BUTTON_SIZES = BUTTON_SIZES;
const BUTTON_ICON_POSITIONS = ["before", "after"];
exports.BUTTON_ICON_POSITIONS = BUTTON_ICON_POSITIONS;